(function (Drupal, once) {
  Drupal.behaviors.navigation = {
    attach: function (context) {
      const setExpanded = function (element, isExpanded) {
        element.setAttribute('aria-expanded', isExpanded ? 'true' : 'false');
      };

      const toggleExpanded = function (element) {
        const isExpanded = element.getAttribute('aria-expanded') === 'true';
        setExpanded(element, !isExpanded);
        return !isExpanded;
      };

      const getNextMenu = function (trigger) {
        const nextElement = trigger.nextElementSibling;
        return nextElement && nextElement.matches('ul') ? nextElement : null;
      };

      const setTabIndex = function (elements, value) {
        Array.from(elements).forEach(function (element) {
          element.setAttribute('tabindex', String(value));
        });
      };

      const syncDrawerOverflowState = function () {
        document.querySelectorAll('.main-nav-drawer__content').forEach(function (drawerContent) {
          const hasExpandedMainSubmenu = Boolean(
            drawerContent.querySelector('.dropdown-trigger__main[aria-expanded="true"]')
          );

          drawerContent.classList.toggle('has-expanded-main-submenu', hasExpandedMainSubmenu);
        });
      };

      const resetSubmenuTriggers = function (scope) {
        scope.querySelectorAll('.dropdown-trigger__submenu').forEach(function (trigger) {
          setExpanded(trigger, false);
        });
      };

      const resetMainMenu = function (scope) {
        scope.querySelectorAll('.dropdown-trigger__main').forEach(function (trigger) {
          setExpanded(trigger, false);

          const menu = getNextMenu(trigger);

          if (menu) {
            setTabIndex(menu.querySelectorAll('a, button'), -1);
            menu.scrollTop = 0;
            menu.removeAttribute('style');
            resetSubmenuTriggers(menu);
          }
        });

        syncDrawerOverflowState();
      };

      const activateExpandedMenu = function (menu) {
        if (!menu) {
          return;
        }

        menu.scrollTop = 0;
        menu.setAttribute('tabindex', '-1');

        requestAnimationFrame(function () {
          menu.focus({ preventScroll: true });
        });
      };

      const syncExpandedMenuHeight = function (menu) {
        if (!menu) {
          return;
        }

        const drawerContent = menu.closest('.main-nav-drawer__content');

        if (!drawerContent) {
          return;
        }

        const availableHeight = drawerContent.clientHeight - menu.offsetTop;

        if (availableHeight > 0) {
          menu.style.height = `${availableHeight}px`;
          menu.style.maxHeight = `${availableHeight}px`;
        }
      };

      const syncOpenMenus = function () {
        document.querySelectorAll('.dropdown-trigger__main[aria-expanded="true"]').forEach(function (trigger) {
          syncExpandedMenuHeight(getNextMenu(trigger));
        });
      };

      const getDesktopSearchInputs = function () {
        return document.querySelectorAll('.main-nav-content .views-exposed-form input[type="text"]');
      };

      const syncMobileDrawerTop = function (isExpanded) {
        const isMobile = window.matchMedia('(max-width: 767px)').matches;

        document.querySelectorAll('.main-nav-drawer').forEach(function (drawer) {
          if (!isExpanded || !isMobile) {
            drawer.style.top = '';
            return;
          }

          const bar = drawer.closest('.main-nav-wrap');
          if (!bar) {
            return;
          }

          drawer.style.top = `${Math.round(bar.getBoundingClientRect().bottom)}px`;
        });
      };

      const closeMainNavigation = function () {
        document.querySelectorAll('.toggle-main-navigation').forEach(function (toggle) {
          setExpanded(toggle, false);
        });

        document.querySelectorAll('.main-nav-drawer').forEach(function (drawer) {
          resetMainMenu(drawer);
        });

        document.querySelector('main')?.classList.remove('nav-open');
        document.documentElement.classList.remove('no-scroll');

        document.querySelectorAll('.main-nav-drawer').forEach(function (drawer) {
          drawer.classList.remove('expanded');
        });
        syncMobileDrawerTop(false);

        syncDrawerOverflowState();
      };

      once('primary-nav-toggle-main', '.toggle-main-navigation', context).forEach(function (toggle) {
        toggle.addEventListener('click', function () {
          const isExpanded = toggleExpanded(toggle);

          if (isExpanded) {
            document.querySelectorAll('.main-nav-drawer').forEach(function (drawer) {
              resetMainMenu(drawer);
            });
          }

          document.querySelector('main')?.classList.toggle('nav-open', isExpanded);
          document.documentElement.classList.toggle('no-scroll', isExpanded);

          document.querySelectorAll('.main-nav-drawer').forEach(function (drawer) {
            drawer.classList.toggle('expanded', isExpanded);
          });
          syncMobileDrawerTop(isExpanded);
        });
      });

      once('primary-nav-dropdown-main', '.dropdown-trigger__main', context).forEach(function (trigger) {
        trigger.addEventListener('click', function () {
          const isExpanded = trigger.getAttribute('aria-expanded') === 'true';
          const currentMenu = getNextMenu(trigger);
          const menuItems = currentMenu?.querySelectorAll('a, button') || [];

          setExpanded(trigger, !isExpanded);
          setTabIndex(menuItems, isExpanded ? -1 : 0);

          if (!isExpanded) {
            syncExpandedMenuHeight(currentMenu);
            activateExpandedMenu(currentMenu);
          }

          document.querySelectorAll('.dropdown-trigger__main').forEach(function (otherTrigger) {
            if (otherTrigger === trigger) {
              return;
            }

            setExpanded(otherTrigger, false);

            const otherMenu = getNextMenu(otherTrigger);

            if (otherMenu) {
              setTabIndex(otherMenu.querySelectorAll('a, button'), -1);
            }
          });

          syncDrawerOverflowState();
        });
      });

      once('primary-nav-dropdown-submenu', '.dropdown-trigger__submenu', context).forEach(function (trigger) {
        trigger.addEventListener('click', function () {
          toggleExpanded(trigger);
        });
      });

      once('primary-nav-back-trigger', '.back-trigger', context).forEach(function (backTrigger) {
        backTrigger.addEventListener('click', function () {
          const currentMenu = backTrigger.closest('ul');

          if (!currentMenu) {
            return;
          }

          currentMenu.style.left = '100%';

          setTimeout(function () {
            document.querySelectorAll('.dropdown-trigger__main').forEach(function (trigger) {
              setExpanded(trigger, false);
            });

            currentMenu.removeAttribute('style');
            syncDrawerOverflowState();
          }, 250);
        });
      });

      once('primary-nav-document-click', 'html', document).forEach(function () {
        document.addEventListener('click', function (event) {
          if (!event.target.closest('.main-nav-content')) {
            closeMainNavigation();
          }
        });
      });

      once('primary-nav-resize', 'html', document).forEach(function () {
        window.addEventListener('resize', function () {
          syncOpenMenus();
        });
      });

      once('primary-nav-search-input', '.main-nav-content .views-exposed-form input[type="text"]', context).forEach(function (input) {
        input.addEventListener('focus', function () {
          document.querySelectorAll('.search-suggestions').forEach(function (suggestions) {
            suggestions.classList.add('open');
          });

          getDesktopSearchInputs().forEach(function (searchInput) {
            searchInput.classList.add('filled');
          });
        });

        input.addEventListener('blur', function () {
          setTimeout(function () {
            document.querySelectorAll('.search-suggestions').forEach(function (suggestions) {
              suggestions.classList.remove('open');
            });

            getDesktopSearchInputs().forEach(function (searchInput) {
              searchInput.classList.remove('filled');
            });
          }, 300);
        });
      });

      once('primary-nav-search-suggestion', '.search-suggestions a', context).forEach(function (link) {
        link.addEventListener('click', function (event) {
          event.preventDefault();

          const isMobile = window.innerWidth < 769;
          const searchInput = document.querySelector(
            isMobile ?
              '.main-nav-drawer__content .views-exposed-form input[type="text"]' :
              '.main-nav-content .views-exposed-form input[type="text"]'
          );

          if (searchInput) {
            searchInput.focus();
            searchInput.value = link.textContent;
            searchInput.classList.remove('filled');
          }
          window.location = '/search?keyword=' + link.textContent + '&sort_by=score';
          //link.closest('form')?.submit();
        });
      });
    }
  };
})(Drupal, window.once);